import {
  IError,
  IProfileConsentManagement,
  IQueryHookOptions,
} from '@comptia-sso/core';
import { useQuery } from 'react-query';

// Services.
import { getConsentManagement } from 'services';

type UseProfileConsentManagement = [
  IProfileConsentManagement,
  IQueryHookOptions,
];

export const useProfileConsentManagement = (
  profileId = '',
): UseProfileConsentManagement => {
  const {
    data = {} as IProfileConsentManagement,
    error,
    isError,
    isLoading,
  } = useQuery<IProfileConsentManagement, IError>(
    ['consentManagement', profileId],
    () => getConsentManagement(profileId),
    {
      enabled: !!profileId,
    },
  );

  return [data, { error, isError, isLoading }];
};
